import styled from '@emotion/styled';
// import { Flex, Text } from 'common/styles';
import StaticText from 'common/StaticText';
import { __t } from 'common/i18n';
import DownloadApps from 'common/DownloadApps';
// import SocialLinks from 'common/SocialLinks';
import StaticLayout from 'common/Layout/StaticLayout';
// import AboutUsLinks from 'common/AboutUsLinks';
import Seo from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';

const VideoWrapper = styled.video(({ theme }) => ({
  width: '100%',
  height: 'auto',
  marginBottom: `${theme.spacings[4]}rem`,
}));

export default function About() {
  return (
    <>
      <Seo
        title={`${__t('static.about.title')} | ${__t('static_siteName')}`}
        description="فیلم‌نت اولین پلتفرم رسمی VOD در ایران است. از سال ۱۳۹۳ با هدف ارائه محتوای قانونی فعالیت می‌کند و امروز آرشیوی گسترده از فیلم، سریال و مستند دارد."
        path="/about"
      />
      <Breadcrumb items={[
        { name: __t('common.home'), url: '/' },
        { name: __t('static.about.title'), url: '/about' },
      ]} />
      <StaticLayout cover="/static/images/static_pages/about_us_cover_img.jpg" title={__t('static.about.title')}>
        <StaticText variant="body1" mb={4}>{__t('static.about.intro')}</StaticText>
        <VideoWrapper
          controls
          muted
          autoPlay
          src="https://static.filmnet.ir/dl/aboutus-video.mp4"
        />
        <StaticText variant="body1" mb={4}>{__t('static.about.effort')}</StaticText>
        <StaticText variant="body1" mb={4}>{__t('static.about.team')}</StaticText>
        <StaticText variant="body1" mb={8}>{__t('static.about.future')}</StaticText>
        <DownloadApps />
        {/* <AboutUsLinks /> */}
        {/* <Text variant="h2" align="center" mb={4}>{__t('static.about.follow.us')}</Text> */}
        {/* <Flex justify="center"> */}
        {/*   <SocialLinks /> */}
        {/* </Flex> */}
      </StaticLayout>
    </>
  );
}
